// @flow

import { Observable, of } from "rxjs";
import { map, catchError, mergeMap } from 'rxjs/operators';
import { ofType } from "redux-observable";

import type { HTTPError } from "../../../../error";
import { postConfirmArrivalApi, endpoints } from "./api";
import { setNewAlert } from "../../../alert/duck";
import type { Order } from "../../../../entities";

export type ReceivedAction = {
  +type: string;
  +orderId?: string;
  +order?: Order;
  +error?: HTTPError;
};

export type ReceivedState = {
  isProgressing: boolean;
  error?: HTTPError;
};

// Actions
const RECEIVED_POST_ARRIVED_REQUEST = 'RECEIVED_POST_ARRIVED_REQUEST';
const RECEIVED_POST_ARRIVED_SUCCESS = 'RECEIVED_POST_ARRIVED_SUCCESS';
const RECEIVED_POST_ARRIVED_ERROR = 'RECEIVED_POST_ARRIVED_ERROR';

// Action Creators
export function confirmArrival(orderId: string): ReceivedAction {
  return {
    type: RECEIVED_POST_ARRIVED_REQUEST,
    orderId,
  }
}

export function confirmArrivalSuccess(order: Order): ReceivedAction {
  return {
    type: RECEIVED_POST_ARRIVED_SUCCESS,
    order,
  }
}

export function confirmArrivalError(error: HTTPError): ReceivedAction {
  return {
    type: RECEIVED_POST_ARRIVED_ERROR,
    error,
  }
}

export const actions = {
  RECEIVED_POST_ARRIVED_REQUEST,
  RECEIVED_POST_ARRIVED_SUCCESS,
  RECEIVED_POST_ARRIVED_ERROR,
  confirmArrival,
  confirmArrivalSuccess,
  confirmArrivalError,
};

export const initialState: ReceivedState = {
  isProgressing: false,
};

// Reducer
export default function reducer(state: ReceivedState = initialState,
                                action: ReceivedAction): ReceivedState {
  switch (action.type) {
    case RECEIVED_POST_ARRIVED_REQUEST:
      return {
        isProgressing: true,
      };
    case RECEIVED_POST_ARRIVED_SUCCESS:
      return {
        isProgressing: false,
      };
    case RECEIVED_POST_ARRIVED_ERROR:
      return {
        isProgressing: false,
        error: action.error,
      };
    default:
      return state;
  }
}

export function confirmArrivalEpic(action$: Observable<ReceivedAction>): Observable<ReceivedAction> {
  return action$.pipe(
    ofType(RECEIVED_POST_ARRIVED_REQUEST),
    mergeMap(
      ({ orderId }) => postConfirmArrivalApi(undefined, {
        route: endpoints.POST_CONFIRM_ARRIVAL.replace(':orderId', orderId),
      }).pipe(
        map(confirmArrivalSuccess),
        catchError(
          (e: HTTPError) => {
            if (Math.round(e.code / 100) === 5) {
              return of(confirmArrivalError(e),
                setNewAlert('order', 'error', undefined, 'httpErrors.fetch.500'),
              );
            } else if (e.code === 400) {
              return of(confirmArrivalError(e),
                setNewAlert('order', 'error', undefined, 'httpErrors.fetch.400'),
              );
            }
            return of(confirmArrivalError(e))
          }
        )
      )
    )
  )
}



// WEBPACK FOOTER //
// ./src/modules/order/Sale/received/duck.js